export default {
  "base": "align-text-top"
}